import React from 'react'
import { INPUT_TYPE } from '../../../models/form'
import './../form.scss'
import { PropsType } from '../../../models/util'
import Select from './Select'
import TextInput, { TextInputProps } from './TextInput'
import TextArea from './TextArea'
import DatePicker, { DatePickerProps } from './DatePicker'
import DateRangePicker, { DateRangePickerProps } from './DateRangePicker'
import MultiSelect from './MultiSelect'

class InputWrapperProps
    implements PropsType, DateRangePickerProps, DatePickerProps, TextInputProps
{
    type: INPUT_TYPE // specifies the required input type
    onChangeCallback: (e: any) => void // on change callback
    value: any // input value(s), could be string, string[], Date, {start: Date, end: Date}

    // to override primereact and/or wardrobe styles, use custom classes
    classes?: string // css classes for the element
    containerClasses?: string // css classes for the <div> container
    containerClasses2?: string // DateRangePicker: css classes for the 'end' <div> container (if specified overrides container classes for the end input)
    style?: any

    optionsList?: any[] // options list for select and multiselect
    filterable?: boolean // adds searchbar for select and multiselect dropdowns
    selectAllLabel?: boolean // multiselect 'select all' label TODO fix

    mandatory?: boolean // adds * in labels (TODO validation message)
    clearable?: boolean // add 'x' icon to clear the field
    disabled?: boolean // if true the element is disabled
    colWidth?: number | string // set element width from 1 to 12 columns (default: 12)

    label?: string // label
    // label2?: string // secondary label (used for DateRangePicker)
    floatingLabel?: boolean // floating labels appear only when the field is filled in
    placeholder?: string // placeholder
    // placeholder2?: string // secondary placeholder (used for DateRangePicker)

    maxDate?: Date // maximum date (for start and end date)
    minDate?: Date // minimum date (for start and end date)
    maxStartDate?: Date // maximum date for start date
    minEndDate?: Date // minimum date for end date
    firstDayOfWeek?: number // first day of the week in month table

    onRemoveChip?: (e: any) => void // TODO fix

    additionalProps?: Record<string, any> // pass props for the Prime React original component
    itemTemplate?: any // dropdown options items template
    panelClassName?: string // panel className

    showSelectedCount?: boolean // whether show or not the item count after the maxSelectedLabels limit
    maxSelectedLabels?: number // number that defines how many labels are shown inside the multiselect
}

const InputWrapper = (props: InputWrapperProps) => {
    const { type } = props

    switch (type) {
        case INPUT_TYPE.select:
            return <Select {...props} />
        case INPUT_TYPE.text:
            return <TextInput {...props} />
        case INPUT_TYPE.textarea:
            return <TextArea {...props} />
        case INPUT_TYPE.number:
            return <TextInput {...props} /> // TODO number
        case INPUT_TYPE.date:
            return <DatePicker {...props} />
        case INPUT_TYPE.daterange:
            return <DateRangePicker {...props} />
        case INPUT_TYPE.multiselect:
            return <MultiSelect {...props} />
        default:
            return <TextInput {...props} />
    }
}

export default InputWrapper
